// extracted by mini-css-extract-plugin
module.exports = {"countDown":"styles_countDown__1FEE5","group":"styles_group__1dGDU","number":"styles_number__1VTTb","separator":"styles_separator__nh7q6"};